import { render, staticRenderFns } from "./AccountOrganisationAccess.vue?vue&type=template&id=601e4b19&"
import script from "./AccountOrganisationAccess.vue?vue&type=script&lang=ts&"
export * from "./AccountOrganisationAccess.vue?vue&type=script&lang=ts&"
import style0 from "./AccountOrganisationAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports